import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as registerWithCodeActionCreators from '../redux/modules/registerWithCode'
import { db } from '../config/firebaseconfig'

import { RegisterWithCode } from '../components/Users'
import jeffCounter from '../helpers/users/testing/jeffCounter';

class RegisterWithCodeContainer extends Component {
  constructor(props) {
    super(props)

    this.submitCode = this.submitCode.bind(this)
  }

  componentDidMount() {
    let registrationCode = ''
    if (this.props.match.params.code) {
      registrationCode = this.props.match.params.code
      this.props.fetchingCode()
      db.collection('registrationCodes').doc(registrationCode).get()
        .then((doc) => {
          if (doc.exists) {
            this.props.fetchingCodeSuccess(doc.data())
          } else {
            this.props.fetchingCodeError('Code not found.')
          }
        })
        .catch((err) => this.props.fetchingCodeError(err))
    }

  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.code !== nextProps.match.params.code) {
      let registrationCode = ''
      if (nextProps.match.params.code) {
        registrationCode = nextProps.match.params.code
        db.collection('registrationCodes').doc(registrationCode).get()
        .then((doc) => {
          if (doc.exists) {
            this.props.fetchingCodeSuccess(doc.data())
          } else {
            this.props.fetchingCodeError('Code not found.')
          }
        })
        .catch((err) => this.props.fetchingCodeError(err))
      } else {
        this.props.fetchingCodeSuccess('')
      }
    }
  }

  submitCode(code) {
    this.props.history.push(`/register/${code}`)
  }

  render() {
    let code = ''
    if (this.props.match.params.code) {
      code = this.props.match.params.code
    }

    return (
      <RegisterWithCode 
        code={this.props.code}
        isFetchingCode={this.props.isFetchingCode}
        isFetchingCodeError={this.props.isFetchingCodeError}
        clearError={this.props.clearError}
        submitCode={this.submitCode}
        history={this.props.history}
      />
    )
  }
}

export default connect(
  (state) => ({
    isSaving: state.registerWithCode.isSaving,
    isFetchingCode: state.registerWithCode.isFetchingCode,
    isFetchingCodeError: state.registerWithCode.isFetchingCodeError,
    code: state.registerWithCode.code,
  }),
  (dispatch) => bindActionCreators(registerWithCodeActionCreators, dispatch)
)(RegisterWithCodeContainer)


// WEBPACK FOOTER //
// ./src/containers/RegisterWithCodeContainer.js